import { ERROR_MESSAGES } from 'config';

const NETWORK_ERROR_PATTERNS = [
  'Failed to fetch',
  'NetworkError',
  'Network request failed',
  'Load failed',
  'fetch failed',
];

export function isNetworkError(error: unknown): boolean {
  if (error instanceof TypeError) {
    return true;
  }

  if (error instanceof Error) {
    return NETWORK_ERROR_PATTERNS.some((pattern) => error.message.includes(pattern));
  }

  return false;
}

export function getUserFacingErrorMessage(
  error: unknown,
  fallback: string = ERROR_MESSAGES.SERVER_ERROR
): string {
  if (isNetworkError(error)) {
    return ERROR_MESSAGES.NETWORK_ERROR;
  }

  if (error instanceof Error && error.message) {
    return error.message;
  }

  return fallback;
}
